import { ColorScheme } from '../services/color-scheme/color-scheme.models';

export class UpdateColorScheme {
    public static readonly type = '[User Settings] UpdateColorScheme';
    constructor(public colorScheme: ColorScheme) { }
}
